<script>
import { createEventDispatcher } from 'svelte'
const dispatch = createEventDispatcher()

import { fade } from 'svelte/transition'
import { onMount } from 'svelte'

let currentTime = 0
let introVideo
let hide = false
onMount( () => {
    introVideo.addEventListener( "canplay" , () => {
        dispatch('visible',true)
    })
    introVideo.addEventListener( "timeupdate" , () => {
        if(hide) return;        

        hide = introVideo.currentTime > 6
        if(hide) setTimeout( () => { dispatch('visible',false) } , 1000 )
    } )
} )
</script>

<style>
.video{ position:absolute; top:0px; left:0px; width:100%; height:100%; transition: opacity 2s ease-in-out; opacity:1; }

@media (max-width: 768px){
    video.video{ width:auto; max-width:none; height:800px; margin-left:-90%; }
}

.hide{ opacity:0; }
</style>

<video class="video" class:hide muted autoplay playsinline bind:this={introVideo}>
    <source src="./res/videos/intro.webm" type="video/webm" />            
    <source src="./res/videos/intro.ogg" type="video/ogg" />
    <source src="./res/videos/intro.mp4" type="video/mp4" />            
</video>